import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
declare var $: any;
import QRCode from 'easyqrcodejs';
import { ObsidiamJweComponent } from 'projects/obsidiam-jwe/src/public-api';
@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {
  @ViewChild('qrcodeDeposit') qrcodeDeposit: ElementRef;
  code: any;
  authId: any = 0;
  userame: any = '';
  userInfo: any = {};
  errorMsg: any = '';
  authError: any = '';
  loading: any = false;
  authy: any = {};
  constructor(private authService: AuthService,
    private cookieService: CookieService,
    private obsidiamJweComponent: ObsidiamJweComponent,
    private router: Router) {
    this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    console.log(this.userInfo);
    if (this.userInfo.qrAuthenticator) {
      this.generateQrCode(this.userInfo.qrAuthenticator)
    }
    this.authy.browser = this.authService.getBrowserName();
  }
  verify() {
    $('.hvr-sweep-to-right').attr('disabled', true);
    this.loading = true;
    this.errorMsg = '';
    this.obsidiamJweComponent.encodeJwe(true, this.authy, resEnc => {
    this.authService.verify(resEnc).toPromise().then((m: any) => {
      this.loading = false;
      if (m.status === 200) {
        this.authService.isLoggedIn = true;
        this.cookieService.set('OBSIDIAM-ADIMIN-AUTH', JSON.stringify(m.data));
        localStorage.removeItem('login');
        localStorage.removeItem('userInfo');
        this.router.navigate(['/dashboard']);
        // location.reload();
      } else {
        this.errorMsg = m['message'];
      }
    });
  });
  }
  ngOnInit() {
    // this.authService.getIp().subscribe((m: any) => {
    //   this.loading = false;
    //   this.authy.ipAddress = m.ip;
    //   this.authy.source = 'Website';
    //   this.authy.location = m.city + ',' + m.country_name;
    //   this.authy.userId = this.userInfo.userId;
    //   this.authy.authToken = this.userInfo.authToken;
    //   $('.vr-wrong').hide();
    //   $('.vr-right').show();
    // });

    this.authy.source = 'Website';
    this.authy.userId = this.userInfo.userId;
    this.authy.authToken = this.userInfo.authToken;
    $('.vr-wrong').hide();
    $('.vr-right').show();

    if (!localStorage.getItem('userInfo')) {
      this.router.navigate(['/login']);
    }
    $('.resendMessage').hide();
    // setTimeout(() => {
    //   $('.resendMessage').hide();
    // }, 100);
  }
  generateQrCode(code) {
    setTimeout(() => {
      this.qrcodeDeposit.nativeElement.innerHTML = '';
      new QRCode(this.qrcodeDeposit.nativeElement, {
        // text: this.selectedCoin.address,
        text: code,
        logo: 'https://cdn-dev.obsidiam.com/img/obsidiam_obIcon.png',
        logoWidth: undefined,
        logoHeight: undefined,
        logoBackgroundTransparent: true
      });
    }, 100);
  }

}
